"use client"

import s from "@/styles/modules/components/cookiebox.module.scss";

import Link from "next/link";

import { FooterOptionsQuery } from "@/types/wordpressQueries";

import React, { useEffect, useState } from 'react';


interface CookieProps {
  footerOptions: FooterOptionsQuery;
  lang: string;
}
const COOKIE_NAME = 'ama_irs_policy'; // Fixed cookie name

export default function CookieBox({ footerOptions, lang }: CookieProps) {

  const [accepted, setAccepted] = useState<boolean>(false);
  const [showBanner, setShowBanner] = useState<boolean>(false);

  // Function to check if the specified cookie exists
  const checkCookie = () => {
    const cookies = document.cookie.split(';').map(cookie => cookie.trim());
    return cookies.some(cookie => cookie.startsWith(`${COOKIE_NAME}=`));
  };

  useEffect(() => {
    // Check if the cookie exists
    const cookieExists = checkCookie();

    // Update state to hide the popup if the cookie exists
    if (cookieExists) {
      setAccepted(true);
    } else {
      setShowBanner(true); // Show the cookie banner if the cookie doesn't exist
    }
  }, []); // Run this effect only once on component mount

  const acceptCookie = () => {
    // Set cookie value and mark as accepted
    document.cookie = `${COOKIE_NAME}=true; max-age=2592000; path=/`; // Set cookie to expire in 30 days (in seconds)
    // 
    setShowBanner(false); // Hide the cookie banner after accepting the cookie
    setTimeout(() => {
      setAccepted(true);
    }, 600)

  };

  if (accepted) {
    return null; // If cookie has been accepted, do not render the component
  }

  return (
    <div className={`${s.cookiebox} ${showBanner ? s.showBanner : ''}`}>
      <div className={s.cookieboxIn}>
        <div className={s.cookieboxInTop}>
          <p data-lang={lang}>
            {lang === "en"
              ? footerOptions.footerOptions.optionsFooter.cookiebox.text && (
                <>{footerOptions.footerOptions.optionsFooter.cookiebox.text}</>
              ) :
              footerOptions.footerOptionsDE.optionsFooter.cookiebox.text && (
                <>{footerOptions.footerOptionsDE.optionsFooter.cookiebox.text}</>
              )
            }
          </p>
        </div>
        <div className={s.cookieboxInButtons}>
          {lang === "en"
            ? footerOptions.footerOptions.optionsFooter.cookiebox.link.url && (
              <Link href={footerOptions.footerOptions.optionsFooter.cookiebox.link.url} dangerouslySetInnerHTML={{
                __html: footerOptions.footerOptions.optionsFooter.cookiebox.link.title,
              }}></Link>
            ) :
            footerOptions.footerOptionsDE.optionsFooter.cookiebox.link.url && (

              <Link href={footerOptions.footerOptionsDE.optionsFooter.cookiebox.link.url} dangerouslySetInnerHTML={{
                __html: footerOptions.footerOptionsDE.optionsFooter.cookiebox.link.title,
              }}></Link>
            )
          }
          <button
            onClick={acceptCookie} >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};
